export interface ClinicInfo {
  cnpj: string;
  razaoSocial: string;
  nomeFantasia: string;
  reportBranding: {
    displayName: string;
    logoPrint: string;
    logoMark: string;
    logoAlt: string;
  };
  endereco: {
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    estado: string;
    cep: string;
    enderecoCompleto: string;
  };
  contato: {
    telefone: string;
    telefoneFull: string;
    whatsapp: string;
    whatsappFull: string;
    email: string;
  };
  horarios: {
    semana: string;
    sabado: string;
    domingo: string;
  };
  bancarios: {
    banco: string;
    agencia: string;
    conta: string;
    pix: string;
    pixTipo: string;
    beneficiario: string;
  };
  logo: string;
  logoPrint: string;
  especialidades: string;
  redesSociais: {
    instagram: string;
    youtube: string;
  };
}

export const clinicInfo: ClinicInfo = {
  cnpj: '43.070.154/0001-62',
  razaoSocial: 'Revalidatie Fisioterapia e Ensino LTDA',
  nomeFantasia: 'Revalidatie',
  reportBranding: {
    displayName: 'Revahub',
    logoPrint: '/logos/revahub-wordmark.png',
    logoMark: '/logos/revahub-mark.png',
    logoAlt: 'Revahub'
  },

  endereco: {
    logradouro: 'Av. Tiradentes',
    numero: '501',
    complemento: 'Torre 2, Sala 201',
    bairro: 'Jd Shangri-lá',
    cidade: 'Londrina',
    estado: 'PR',
    cep: '86070-545',
    enderecoCompleto: 'Av. Tiradentes, 501, Torre 2, Sala 201, Jd Shangri-lá, Londrina - PR, CEP: 86070-545'
  },

  contato: {
    telefone: '(43) 3398-9011',
    telefoneFull: '+554333989011',
    whatsapp: '(43) 3398-9011',
    whatsappFull: '554333989011',
    email: 'revalidatie_londrina@outlook.com'
  },

  horarios: {
    semana: 'Seg-Sex: 7:30h às 18:30h',
    sabado: 'Sáb: 7:30h às 13:30h',
    domingo: 'Fechado'
  },

  bancarios: {
    banco: 'Banco Itaú',
    agencia: '1555',
    conta: '99117-1',
    pix: '43070154000162',
    pixTipo: 'CNPJ',
    beneficiario: 'Revalidatie F E LTDA'
  },

  logo: '/logo.svg',
  logoPrint: '/logos/revahub-wordmark.png',
  especialidades: 'Fisioterapia e Reabilitação Cardiorrespiratória e Oncológica',

  redesSociais: {
    instagram: 'https://instagram.com/revalidatie_londrina',
    youtube: 'https://www.youtube.com/@revacast'
  }
};

export const clinicAddressLine = `${clinicInfo.endereco.logradouro}, ${clinicInfo.endereco.numero}, ${clinicInfo.endereco.complemento} - ${clinicInfo.endereco.bairro}`;
export const clinicLocationLine = `${clinicInfo.endereco.cidade} - ${clinicInfo.endereco.estado} | CEP: ${clinicInfo.endereco.cep}`;
export const clinicContactLine = `Tel: ${clinicInfo.contato.telefone} | Email: ${clinicInfo.contato.email}`;
export const clinicLegalLine = `${clinicInfo.razaoSocial} - CNPJ: ${clinicInfo.cnpj}`;
export const reportSystemLine = `Este documento foi gerado eletronicamente pelo sistema ${clinicInfo.reportBranding.displayName}`;

export default clinicInfo;
